<ng-container *ngIf="!isMaintenanceMode && !isFronteggLoading">
  <ng-container [ngSwitch]="spThemeName">
    <ng-container *ngSwitchCase="'dashboard-desk'">
      <div class="sp-layout-{{spThemeName}} sp-h-100">
        <app-sp-layout-dashboard-desk></app-sp-layout-dashboard-desk>
      </div>
    </ng-container>
    <ng-container *ngSwitchCase="'dashboard-simple'">
      <div class="sp-layout-{{spThemeName}} sp-h-100">
        <app-sp-layout-dashboard-simple></app-sp-layout-dashboard-simple>
      </div>
    </ng-container>
    <ng-container *ngSwitchDefault>
      <div class="sp-layout-dashboard-default sp-h-100">
        <app-sp-layout-dashboard-default></app-sp-layout-dashboard-default>
        <app-sp-tools *ngIf="loader.loadingGlobal"></app-sp-tools>
      </div>
    </ng-container>
  </ng-container>
</ng-container>
<app-sp-page-maintenance *ngIf="isMaintenanceMode"></app-sp-page-maintenance>
<ng-container *ngIf="env.config.enableDebugFeatures && isDebugBoxVisible()">
  <div id="sp-debug-box">
    <h5 id="sp-debug-title">Debugging</h5>
    <div id="sp-debug-content" [innerHTML]="debugOutput"></div>
    <div style="margin-left: 1em; margin-right: 1em" *ngFor="let featureFlag of debugFeatureFlags">{{featureFlag.flag}} <mat-slide-toggle (change)="updateFeatureFlag(featureFlag.flag, $event.checked)" [checked]="featureFlag.active"></mat-slide-toggle></div>
  </div>
</ng-container>
<button *ngIf="env.config.enableDebugFeatures" (click)="toggleDebugBox()" id="sp-debug-button" [ngClass]="{'sp-debug-button-enabled': this.isDebugBoxVisible()}">
  <mat-icon style="vertical-align: middle">bug_report</mat-icon>
</button>

